// Placeholder for future route disabling.
// Currently all routes are active. Add paths to `disabled` to redirect them to DASHBOARD.
export default defineNuxtRouteMiddleware((to) => {
  const disabled: string[] = []
  if (disabled.some((p) => to.path.startsWith(p))) {
    return navigateTo(ROUTES.DASHBOARD)
  }
})
